import { Box, createStyles, makeStyles } from '@material-ui/core'
import React from 'react'
import { Colors } from 'src/components/atoms'

export interface FolderNameCellProps {
  value?: string | null
}

const useStyles = makeStyles(() => {
  return createStyles({
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '4px 8px',
      backgroundColor: '#E8E7FC',
      color: Colors.accent.keyPurple.default,
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: 500,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%'
    },
    empty: {
      color: Colors.base.middleGray,
      fontSize: '12px'
    }
  })
})

export const FolderNameCell = ({ value }: FolderNameCellProps) => {
  const classes = useStyles()

  if (!value) {
    return (
      <Box width={1} display="flex" alignItems="center">
        <span className={classes.empty}>-</span>
      </Box>
    )
  }

  return (
    <Box width={1} display="flex" alignItems="center">
      <span className={classes.badge}>{value}</span>
    </Box>
  )
}
